import { useMemo } from 'react';
import { Button, cn } from '@zep-us/zus';
import { BoltFillIcon, ChevronRightIcon } from '@zep-us/zus-icons';
import { useTranslation } from 'next-i18next';
import { useUser } from '@/lib/auth';
export interface PremiumMapBannerProps {
  /** 플랜 구매 버튼 클릭 핸들러 */
  onPlanPurchaseClick?: () => void;
  /** 추가 스타일링을 위한 선택적 className */
  className?: string;
}

/**
 * PremiumMapBanner - 프리미엄 맵으로 제작된 퀴즈를 나타내는 배너
 *
 * @description
 * 그라데이션 텍스트와 플랜 구매를 위한 CTA 버튼이 있는 배너를 표시합니다.
 * 퀴즈가 프리미엄 맵 템플릿을 사용하여 제작되었을 때 표시됩니다.
 *
 * Figma Design Reference: 28185:53792
 *
 * @example
 * ```tsx
 * <PremiumMapBanner onPlanPurchaseClick={handlePlanClick} />
 * ```
 */
export const PremiumMapBanner = ({
  onPlanPurchaseClick,
  className
}: PremiumMapBannerProps) => {
  const {
    t
  } = useTranslation(['common']);
  const {
    user
  } = useUser();
  const shouldShowPlanPurchaseButton = useMemo(() => {
    return !user || user.planType === 'FREE';
  }, [user]);
  return <div className={cn('flex min-h-[40px] w-full flex-wrap items-center justify-center gap-x-sm', 'rounded-sm bg-gray-50 px-xs py-2xs', className)} data-sentry-component="PremiumMapBanner" data-sentry-source-file="PremiumMapBanner.tsx">
      <div className="flex min-w-0 items-center gap-3xs">
        <div className="flex size-md shrink-0 items-center justify-center">
          <BoltFillIcon size="2xs" className="text-violet-400" data-sentry-element="BoltFillIcon" data-sentry-source-file="PremiumMapBanner.tsx" />
        </div>
        <p className="min-w-0 bg-gradient-to-r from-violet-400 to-blue-400 bg-clip-text text-body-md-bold" style={{
        WebkitTextFillColor: 'transparent'
      }}>
          {t('quizItem.detail.createdProExclusiveMap')}
        </p>
      </div>

      {shouldShowPlanPurchaseButton && <Button size="sm" variant="transparent" intent="neutral" onClick={onPlanPurchaseClick}
    // 36px 버튼이 한 줄 배너 높이(40px)를 늘리지 않게 한다.
    className="-my-3xs" rightSlot={<ChevronRightIcon size="2xs" />}>
          {t('detail.planPurchase')}
        </Button>}
    </div>;
};